module.exports = __webpack_public_path__ + "static/media/parents2.b62e49c1.svg";